/** Échappement HTML — toute donnée d'utilisateur (titre, identifiant, URL…)
 * injectée via `innerHTML` doit passer par ici pour éviter une injection. */
export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function qs<T extends HTMLElement>(selector: string, root: ParentNode = document): T {
  const el = root.querySelector<T>(selector);
  if (!el) throw new Error(`qs: element introuvable pour le selecteur "${selector}"`);
  return el;
}
